import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {distinctUntilChanged, map} from 'rxjs/operators';

@Injectable()
export class EffectiveDateService {
    private readonly _effectiveDate$ = new BehaviorSubject<Date | null>(
        new Date(Date.now() + 24 * 60 * 60 * 1000)
    );
    readonly effectiveDate$ = this._effectiveDate$.pipe(
        distinctUntilChanged((a, b) => a?.getTime() === b?.getTime())
    );
    readonly minDate: Date = new Date();

    get effectiveDate(): Date | null {
        return this._effectiveDate$.value;
    }

    setEffectiveDate(date: Date | null): void {
        if (!date) {
            return;
        }
        if (date < this.minDate) {
            date = this.minDate;
        }
        this._effectiveDate$.next(date);
    }
}
